import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-start justify-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20ultra%20luxury%20private%20music%20studio%20interior%20at%20night%20silhouette%20of%20a%20magnificent%20grand%20piano%20under%20dramatic%20single%20spotlight%20beam%20deep%20black%20and%20warm%20charcoal%20walls%20subtle%20champagne%20gold%20accent%20lighting%20from%20recessed%20fixtures%20floating%20dust%20particles%20in%20light%20rays%20minimalist%20zen-like%20silence%20atmosphere%20ultra%20high-end%20executive%20club%20aesthetic%20no%20visible%20text%20or%20logos%20professional%20architectural%20photography&width=1920&height=1080&seq=1&orientation=landscape"
          alt="Luxury music studio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deepblack/50 via-deepblack/35 to-deepblack/75" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-12 lg:px-16 pt-24">
        <div className="w-fit mx-auto text-center">
          <span className="inline-block px-5 py-2 border-2 border-champagne/50 rounded-full text-champagne text-sm font-sans tracking-widest uppercase mb-4 bg-champagne/10">
            {t("hero.tag")}
          </span>

          <h1 className="font-serif text-marble leading-tight">
            <span className="block text-[3.4vw] md:text-2xl lg:text-3xl xl:text-4xl font-light tracking-wide whitespace-nowrap">
              {t("hero.title1")}
            </span>
            <span className="block mt-3 md:mt-4 text-marble text-[11px] md:text-base font-sans font-light tracking-wide whitespace-pre-line leading-relaxed">
              {t("hero.subtitle")}
            </span>
          </h1>
        </div>
      </div>

      {/* Bottom group: button only */}
      <div className="absolute bottom-8 md:bottom-12 left-0 right-0 z-10 px-6 md:px-12 lg:px-16 flex flex-col items-center gap-4">
        <a
          href="/inquiry"
          className="inline-flex items-center gap-3 bg-champagne hover:bg-champagne/90 text-deepblack px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300 group"
        >
          {t("cta.button")}
          <span className="w-6 h-6 rounded-full bg-deepblack/20 flex items-center justify-center group-hover:bg-deepblack/30 transition-colors">
            <i className="ri-arrow-right-line text-deepblack" />
          </span>
        </a>
      </div>
    </section>
  );
}